import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { ListFilter, createDateFilter, createSelectFilter } from '../../../../../Components/ListFilter';

interface IProps {
  setFilter: (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => void;
  filters: any;
}

export const ObservationFilter: FC<IProps> = ({filters, setFilter }) => {
  const { formatMessage } = useIntl();

  const dateFilter = createDateFilter(
    'EffectiveFrom',
    formatMessage({ id: 'utils.filters.sendoutDate.from' }),
    formatMessage({ id: 'utils.filters.sendoutDate.to' }),
  );

    const OpenOption = { value: 1, label: formatMessage({ id: 'utils.filters.status.open' }) };
  const ClosedOption = { value: 3, label: formatMessage({ id: 'utils.filters.status.closed' }) };

  const statusFilter = createSelectFilter(
     'status',
     formatMessage({ id: 'utils.filters.status' }),
     [OpenOption,ClosedOption],
     (option) => option.value.toString(),
    OpenOption,
     filters?.status,
   );

  return <ListFilter filters={[dateFilter,statusFilter]} setFilter={setFilter} />;
};
